/**
 * Chips.js
 * Fill your tag bowl with chips
 *
 * @class Chips
 * @author Robby Sahm
 * 
 * 
 */

import React from 'react';
import ClassNames from 'classnames';
import Paper from 'components/paper/Paper';
import FontIcon from 'components/font-icon/FontIcon';
import TextField from 'components/forms/text-field/TextField';
import Transition from 'components/transition-groups/Transition';

const ReactCSSTransitionGroup = React.addons.CSSTransitionGroup;

export default React.createClass({

	mixins: [React.addons.Update],

	propTypes: {
		selections: React.PropTypes.array,
		type: React.PropTypes.oneOf(['input', 'cloud']),
		key: React.PropTypes.string
	},

	getDefaultProps() {
		return {
			selections: [ 'cat', 'elephant', 'dog', 'chicken', 'pig', 'snake' ],
			type: 'cloud',
			key: ''
		};
	},

	getInitialState() {
		return { 
			selections: [],
			chip_zone_width: 0,
			is_error: false
		};
	},

	componentDidMount() {
		this.setState({ selections: this.props.selections });
		this._getChipZoneWidth();
	},

	componentDidUpdate() {

	},	

	componentWillReceiveProps() {
			
	},

	componentWillUnmount() {

	},

	render() {

		let {
			className,
			type
		} = this.props;

		// var divStyle = {
		// 	opacity: 1,
		// 	WebkitTransition: 'all', // note the capital 'W' here
		// 	msTransition: 'all' // 'ms' is the only lowercase vendor prefix
		// };

		let chips = this.state.selections.map((chip, index) => {

			return (
				<div key={index} className="lui-chip">
					<p>
						{chip}
						<FontIcon 
							key={'close-' + index}
							icon="times"
							chip={chip}
							className="lui-chip-icon"
							onClick={this._removeChip.bind(this, chip)} />
					</p>
				</div>
			)
		});

		// Handle Type Here
		switch(type) {
			case 'cloud':
				return (
					<div className="lui-chips-wrap" depth={0} rounded={true}>
						<div ref="chipzone" className="lui-chip-zone">
							<Transition type="scale">
								{chips}
							</Transition>
							
						</div>
						<TextField
							ref="chipinput"
							onEnterKeyDown={this._addChip}
							placeholder="Multi-select" />
					</div>
				);
			case 'input':
			default:

				let textFieldStyle = {
					paddingLeft: this.state.chip_zone_width
				};

				return (
					<div className="lui-chips-wrap" depth={0} rounded={true}>
						<div ref="chipzone" className="lui-chip-zone">
							{chips}
						</div>
						<TextField
							ref="chipinput"
							errorText={this.state.is_error}
							onEnterKeyDown={this._addChip}
							placeholder="Multi-select"
							style={textFieldStyle} />
					</div>
				);
		}
	},


	_removeChip(chip) {

		let state = this.state.selections.slice(0); // slice clones state object
        let index = state.indexOf(chip);
        let splice = state.splice(index, 1);

        this.setState({ selections: state });

	},

	_addChip() {
		let value = this.refs.chipinput.getValue();

		if (this.state.selections.indexOf(value) === -1)
		{
			let a = this.state.selections.slice(0);
			let arr = a.push(value);

			this.setState({ selections: a });


			this.refs.chipinput.clearValue();
		} else {
			alert(value + ' already exists');
		}
	},
	
	_getChipZoneWidth() {
		var w = React.findDOMNode(this.refs.chipzone).offsetWidth;
		this.setState({ chip_zone_width: w });
	},

	getValue() {
		return this.state.selections;	
	}

});


/** WEBPACK FOOTER **
 ** ./src/components/chips/Chips.js
 **/